import React, { type ReactNode } from 'react';
import styled from 'styled-components';
import ChevronDown from '@splunk/react-icons/ChevronDown';
import ChevronUp from '@splunk/react-icons/ChevronUp';
import Cross from '@splunk/react-icons/Cross';
import ScreenReaderContent from '@splunk/react-ui/ScreenReaderContent';
import Button, { type ButtonClickHandler } from '@splunk/react-ui/Button';
import Tooltip from '@splunk/react-ui/Tooltip';
import { _ } from '@splunk/ui-utils/i18n';

export const labels = {
    close: _('Close Pane'),
    collapse: _('Collapse Pane'),
    expand: _('Expand Pane'),
};

type ButtonProps = {
    dataTest: string;
    icon: ReactNode;
    tooltip: string;
    onClick: ButtonClickHandler;
};

export const ButtonGroup = styled.div.attrs(() => ({
    'data-test': 'flyout-header-button-group',
}))`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

const IconButton = ({ dataTest, icon, tooltip, onClick }: ButtonProps) => (
    <Tooltip contentRelationship="label" content={tooltip} openDelay="primary">
        <Button
            data-test={dataTest}
            appearance="subtle"
            icon={icon}
            onClick={onClick}
        />
    </Tooltip>
);

const CloseButtonIcon = (
    <>
        <Cross />
        <ScreenReaderContent>{labels.close}</ScreenReaderContent>
    </>
);
export const CloseButton = ({ onClick }: Pick<ButtonProps, 'onClick'>) => (
    <IconButton
        dataTest="flyout-header-close-btn"
        icon={CloseButtonIcon}
        tooltip={labels.close}
        onClick={onClick}
    />
);

const CollapseButtonIcon = (
    <>
        <ChevronDown />
        <ScreenReaderContent>{labels.collapse}</ScreenReaderContent>
    </>
);
export const CollapseButton = ({ onClick }: Pick<ButtonProps, 'onClick'>) => (
    <IconButton
        dataTest="flyout-header-collapse-btn"
        icon={CollapseButtonIcon}
        tooltip={labels.collapse}
        onClick={onClick}
    />
);

const ExpandButtonIcon = (
    <>
        <ChevronUp />
        <ScreenReaderContent>{labels.expand}</ScreenReaderContent>
    </>
);
export const ExpandButton = ({ onClick }: Pick<ButtonProps, 'onClick'>) => (
    <IconButton
        dataTest="flyout-header-expand-btn"
        icon={ExpandButtonIcon}
        tooltip={labels.expand}
        onClick={onClick}
    />
);
